import React from "react"
import congrats from "../../../assets/images/congrats.png"
import commonStrings from "../../commonStrings"

const Banner = ({ graphData }) => {
  if (!graphData || !graphData.length) return null
  const indicatorsWithGoals = graphData.filter(
    (item) => item.goal_value !== null,
  )

  const matchedIndicators = indicatorsWithGoals.filter(
    (item) => item.rating !== null && item.rating === item.goal_value,
  )

  if (!matchedIndicators.length) {
    return null
  }
  const achievedCount = matchedIndicators.length
  const totalWithGoals = indicatorsWithGoals.length

  return (
    <div className="main-goal">
      <img className="goal-icon" src={congrats} alt="Goal achieved" />
      <div className="goal-text">
        <span className="goal-achieved-text">
          {commonStrings.congratulations}
        </span>
        <div className="outstanding-text">
          {`You have met ${achievedCount} of your ${totalWithGoals} goals!`}
        </div>
      </div>
      <div className="indicator-percent">
        <span className="indicator-percent-text">
          <span>{achievedCount}</span>
          <span>/</span>
          <span>{totalWithGoals}</span>
        </span>
      </div>
    </div>
  )
}

export default Banner
